export default __webpack_public_path__ + "static/media/169.9f0489f2.svg";